import { useEffect } from 'react';
import { useIsFetching } from '@tanstack/react-query';
import { useAtomValue } from 'jotai';
import { UpdatedTosApprovalModal } from 'src/components/LegalUpdateModal';
import useLogin from 'src/hooks/useLogin';
import { ConsentApiList } from 'src/stores/auth/apis';
import { isUserJustSignedUpAtom, userDataAtom } from 'src/stores/auth/atoms';
import { ConsentInfo } from 'src/types/AzarUser';
import { ModalType } from 'src/types/Modal';
import { MakeRequired } from 'src/types/utils';
import { OrderedModalHookType } from './types';
import withLoginUserModalPromise from './withLoginUserModalPromise';
const useUpdatedConsentModal: OrderedModalHookType = modalPropsPromise => {
  const userData = useAtomValue(userDataAtom);
  const {
    isLogin
  } = useLogin();
  const isUserSignedUp = useAtomValue(isUserJustSignedUpAtom);
  const isFetchingUpdates = useIsFetching({
    queryKey: [ConsentApiList.GetConsentRevision]
  });
  useEffect(() => {
    if (!isLogin) return;

    /**
     * 서버의 비동기 이슈로 인해 회원가입 시점에 약관 동의 기록이 반영되지 않았을 수 있음
     * 방금 회원가입 시점을 마친 유저는 약관 갱신을 체크할 필요가 없으므로 팝업 노출 제약 (앱클라와 동일)
     */
    if (isUserSignedUp) {
      modalPropsPromise?.resolve(null);
      return;
    }
    if (isFetchingUpdates) return;
    const updatedConsentsWithPopup = userData?.consentsRequired?.filter((consent): consent is MakeRequired<ConsentInfo, 'consentRevisionPopup'> => !!consent.consentRevisionPopup);
    if (updatedConsentsWithPopup?.length) {
      modalPropsPromise?.resolve(updatedConsentsWithPopup.map(updatedConsent => {
        return {
          modalProps: {
            key: ModalType.TOS_RE_APPROVAL,
            component: () => <UpdatedTosApprovalModal consent={updatedConsent} />
          }
        };
      }));
    } else {
      modalPropsPromise?.resolve(null);
    }
  }, [isFetchingUpdates, isLogin, isUserSignedUp, modalPropsPromise, userData?.consentsRequired]);
};
export default withLoginUserModalPromise(useUpdatedConsentModal);